var _ellipse, _ellipse2, _rect, _circle, _rect2, _circle2, _rect3, _circle3, _polygon, _polygon2, _polygon3, _g, _path, _path2, _polygon4, _path3, _polygon5, _path4, _path5, _path6, _polygon6, _path7, _polygon7, _circle4, _path8, _path9, _polygon8, _polygon9, _path10, _path11, _polygon10, _path12, _path13, _path14, _path15, _path16, _path17, _polygon11, _path18, _polygon12, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _polygon13, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 939.81117,
    height: 456.60073,
    viewBox: "0 0 939.81117 456.60073",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.24916,
    cy: 304.60073,
    rx: 135,
    ry: 7,
    fill: "#f0f0f0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.24916,
    cy: 449.60073,
    rx: 45,
    ry: 7,
    fill: "#f0f0f0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 761.17635,
    y: 189.86378,
    width: 5.13321,
    height: 98.99767,
    transform: "translate(318.13467 753.22315) rotate(-84.18477)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 557.44851,
    cy: 9.53384,
    r: 9.53311,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 761.17635,
    y: 217.86378,
    width: 5.13321,
    height: 98.99767,
    transform: "translate(290.27876 778.38616) rotate(-84.18477)",
    fill: "#e4e4e4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 557.44851,
    cy: 37.53384,
    r: 9.53311,
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 761.17635,
    y: 245.86378,
    width: 5.13321,
    height: 98.99767,
    transform: "translate(262.42285 803.54918) rotate(-84.18477)",
    fill: "#b715cb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 557.44851,
    cy: 65.53384,
    r: 9.53311,
    fill: "#b715cb"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19.924 166.829 74.249 125.601 73.806 205.874 22.589 248.125 19.924 166.829",
    fill: "#e4e4e4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.922 16.745 362.661 1.81 364.249 93.905 257.852 111.524 256.922 16.745",
    fill: "#b715cb"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "870.249 173.491 870.249 254.894 922.822 305.421 925.276 222.902 870.249 173.491",
    fill: "#b715cb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f1012d9b-0a3f-4e62-89ec-f75ec41b1f18",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f1db56c4-d40a-4b97-925d-862f8518bc4b-306",
    "data-name": "Path 1733",
    d: "M1000.65558,322.07677v12.01l36.63,29.76,1.72-10.3Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#b715cb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a03c9d69-04e1-44a9-b627-9efaf6e70c5d-307",
    "data-name": "Path 1735",
    d: "M1001.2356,342.67678l-.58,12.02,69.25,65.23-1.14-13.73Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "f49e7db1-285b-4bca-9b97-2387afac8e22-308",
    "data-name": "Path 1736",
    d: "M1000.65558,364.99679v11.44l69.25,66.39v-14.88Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#e6e6e6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "149.849 441.23 144.362 441.23 141.751 420.063 149.85 420.063 149.849 441.23",
    fill: "#9e616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.34325,668.24883l-17.69456-.00066v-.2238a6.8876,6.8876,0,0,1,6.88722-6.88711h.00044l10.80723.00044Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "169.309 435.789 164.236 437.882 153.748 419.313 161.234 416.223 169.309 435.789",
    fill: "#9e616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.72669,661.87166,286.37035,668.622l-.08539-.20688a6.88756,6.88756,0,0,1,3.73863-8.9938l.0004-.00017,9.98991-4.12285Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.55878,503.74645s20.36206,9.64972,6.83261,53.85182l-1.02946,34.96981-6.74837,64.28769-10.98-.69935-4.856-61.88755-16.186-51.11662,3.212-24.68933Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.48249,524.98689l1.65576-32.09473c-11.26025-18.90918.281-29.71191,1.21875-30.541l10.31787-15.0669,9.02735-2.478a11.89523,11.89523,0,0,1,15.0437,11.5625l-.40479,52.58691Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#b715cb"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.984 381.916 154.331 428.978 167.334 423.693 149.713 381.096 142.984 381.916",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M255.77738,541.63329a5.71,5.71,0,0,0,2.55729-8.37388l11.50486-16.29311-9.58505-.5492-10.19519,15.35172a5.741,5.741,0,0,0,5.71809,9.86447Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#9e616a"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.675 241.325 134.705 276.81 120.497 303.566 132.386 311.008 152.869 280.727 144.292 237.823 129.675 241.325",
    fill: "#b715cb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "aaba450f-0f04-490f-b553-501192395cc8",
    "data-name": "Ellipse 360",
    cx: 140.10743,
    cy: 202.03381,
    r: 15.18,
    fill: "#9e616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M293.0904,480.33821c.56714-8.49255,4.12256-16.44623,6.98877-24.46057,2.866-8.01441,5.09131-16.737,2.92432-24.968a38.37815,38.37815,0,0,0-5.886-11.79681c-4.7417-6.87683-10.78711-13.27106-18.62109-16.16931-7.834-2.8982-17.70655-1.45343-22.86035,5.12a12.7433,12.7433,0,0,0-2.876,8.2041,9.149,9.149,0,0,0,4.14648,7.44147c1.43116.86621,3.13282,1.27271,4.43555,2.32208,1.30274,1.04944,2.01563,3.183.83057,4.36383l.47314.233c4.24561.91491,6.61426,5.72711,6.57813,10.06994s-1.80225,8.45459-2.89551,12.65772c-1.09326,4.20318-1.41309,9.02362,1.11133,12.55767,2.50927,3.51355,7.35986,5.05939,9.1914,8.96949,2.499,5.33587-2.03027,11.44433-1.48681,17.3114.522,5.63263,5.80127,9.886,11.32617,11.10022,5.5249,1.21417,11.26318.06537,16.80224-1.0827C295.73542,498.258,292.52326,488.8307,293.0904,480.33821Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M644.68733,402.43233l.74121-24.66346-3.29248-22.93652-4.92627.334-4.145,24.134,4.63134,25.876a6.99547,6.99547,0,1,0,6.99122-2.744Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#9e616a"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "513.97 238.601 500.162 297.058 510.566 297.797 530.506 241.219 513.97 238.601",
    fill: "#9e616a"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "538.584 234.759 557.64 291.722 566.872 286.869 552.249 229.601 538.584 234.759",
    fill: "#9e616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M643.3462,407.39644s-6.61624,7.31635,4.80108,21.36014l-14.8037,77.54379,11,4,20-52,18,45,14-6-19.12444-68.54379,2.12444-17.45621-5.28735-4.88583Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#e4e4e4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M657.08626,328.45644s-20.02166,7.84393-18.02166,19.84393l4.9252,47.43587-5.06565,16.45057s33.78386,5.42576,39.96215-.73034l1.1783-52.1561,2.21294-20.615-10.70129-4.329-2.67-3.96Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "512.042 120.652 504.74 137.093 515.596 141.297 512.042 120.652",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M696.86994,409.26045l-8.80517-47.004-14.0083-1.16992,3.94824,23.5957,9.53857,26.69861a7.0029,7.0029,0,1,0,9.32666-2.12036Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#9e616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M666.34732,344.43029l8.079,22.93615,15.63832-2.06607s3.42587-21.23-7.78706-26.615Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "aadf75e6-ac14-4c0d-b07b-d38ba10ebdab-309",
    "data-name": "Path 1770",
    d: "M677.31824,310.95981c-.40748,19.63512-30.652,16.28216-26.64422-3.00847C653.75974,292.60023,677.73029,295.32874,677.31824,310.95981Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#9e616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "e2c3cfee-80d7-4301-b109-7608295bf7e0-310",
    "data-name": "Path 1784",
    d: "M669.94825,292.89981c-9.4821,1.61639-24.16725-2.18534-23.879,12.66035-.97254,1.45384-2.04149,3.04658-1.35075,4.86972,3.34472,4.07892,5.09246,10.39583,9.45868,13.26085,3.89158-.02883,8.97148.51448,11.58125-2.88061,1.10884-2.78394-.853-6.17778.81979-8.79037,2.19295-.69977,4.33336,2.1073,5.19-1.89047a5.43994,5.43994,0,0,1,2.23009-5.08945C677.43193,301.10783,675.09209,293.8623,669.94825,292.89981Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M627.56208,517.301l16.35086-.00066h.00066a10.42059,10.42059,0,0,1,10.42005,10.41988v.33861l-26.77107.001Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M683.72909,510.24285l15.98349-3.44654.00065-.00014a10.42061,10.42061,0,0,1,12.382,7.98987l.07136.331-26.1696,5.64289Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "621.563 299.657 626.846 299.657 629.359 279.281 621.562 279.281 621.563 299.657",
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M750.31011,519.63185l10.40327-.00042h.00042a6.63015,6.63015,0,0,1,6.62978,6.62967v.21545l-17.03315.00063Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "594.563 299.657 599.846 299.657 602.359 279.281 594.562 279.281 594.563 299.657",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M723.31011,519.63185l10.40327-.00042h.00042a6.63015,6.63015,0,0,1,6.62978,6.62967v.21545l-17.03315.00063Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M786.34358,294.30037a6,6,0,1,0-11.54932,2.27905l-12.13965,19.20667-7.55713,15.2301,6.23633,5.535,4.79932-5.05115,15.69629-31.3927A5.99665,5.99665,0,0,0,786.34358,294.30037Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#ffb6b6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M723.34358,357.30037l-11.89942-1.84424-2.83472,21.52759-15.44409,33.23413a6.003,6.003,0,1,0,8.2732,1.9248l16.1477-29.15844Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#ffb6b6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M729.93768,393.163s-10.46415,9.67623-9.13442,34.00664l2.93141,37.58661-.73927,52.39445,10.74783-.84457,9.38977-87.80608,9,36-3.23087,47.956,10.35291.24022,10.878-54.1962-2.57832-40.17392L763.22355,393.163Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M741.133,336.50006l-25,7,12.71159,38.08609-1.9,14.57,38.54669.24969-8.92708-28.16167s5.00976-10.30194-.71071-17.523Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#e4e4e4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M738.133,342.50006l3-6s-.09683-1.50781,6.95158-2.2539l8.27024-8.21985,7.56979,7.54454L751.133,352.50006Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#e4e4e4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M726.133,348.50006s-9-10-14-5-2.43641,20.89895-2.43641,20.89895l15.57331,2.41656Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#e4e4e4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "bf97ead5-a8ed-4eb0-acc5-869eed05cf08-311",
    "data-name": "Ellipse 358",
    d: "M730.69791,310.0607c15.32721.06879,15.32591,23.37334-.00072,23.44C715.3707,333.43191,715.372,310.12737,730.69791,310.0607Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#ffb6b6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M732.40421,321.00606c2.07178,1.22006,4.22463,2.468,6.61469,2.72959s5.096-.74435,6.055-2.94915a6.80354,6.80354,0,0,0,.4695-2.39647,15.93022,15.93022,0,0,0-4.0325-11.41526,14.44626,14.44626,0,0,0-11.086-4.68724c-3.96029.17215-7.62,2.04685-11.13425,3.88088-3.23174,1.68659-6.644,3.545-8.4,6.73957-2.602,4.73379-.70535,10.52951-.2,15.90759a29.96846,29.96846,0,0,1-7.22483,22.29l21.80746,2.0663a25.52412,25.52412,0,0,0,7.9619-.08105,12.726,12.726,0,0,0,6.05225-21.5879c-3.09541-2.98007-8.07337-5.08984-8.19565-9.38489",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#2f2e41"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 152.075 79.881 93.598 79.249 98.601 0.249 157.601 0 152.075",
    fill: "#b715cb"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "e675ae52-c925-4d34-8b81-f405477c3ca7-312",
    "data-name": "Ellipse 365",
    d: "M547.04436,644.75768c22.02626-.09067,22.02646,4.771-.00053,4.68C525.0181,649.52835,525.0179,644.66663,547.04436,644.75768Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "e3c5ec81-3296-48b2-bdc0-fdf32bb949c4-313",
    "data-name": "Ellipse 365",
    d: "M226.04436,642.75768c22.02626-.09067,22.02646,4.771-.00053,4.68C204.0181,647.52835,204.0179,642.66663,226.04436,642.75768Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "a417f11e-12d9-4890-9c52-a0b47cfebf3d-314",
    "data-name": "Ellipse 365",
    d: "M842.04436,557.75768c22.02626-.09067,22.02646,4.771-.00053,4.68C820.0181,562.52835,820.0179,557.66663,842.04436,557.75768Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M840.28534,554.20471c.0448-2.13446-1.48663-4.45325-3.62146-4.46759a3.77441,3.77441,0,0,0-3.46887,3.16675,6.17425,6.17425,0,0,0,1.39587,4.753,18.30648,18.30648,0,0,0,3.80005,3.37915l.37683-1.37457a4.39653,4.39653,0,0,1-.8352.40967C839.081,558.27136,840.24054,556.33917,840.28534,554.20471Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M838.76776,559.66144a4.874,4.874,0,0,0,.89716-.74286c-.24683.04962-.49018.11548-.73773.16125Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M854.796,542.95306a7.31875,7.31875,0,0,0-7.07617-1.10046,8.54471,8.54471,0,0,0-4.98059,5.27179c-.77222,2.2951-.6131,4.78815-.988,7.18042a8.57141,8.57141,0,0,1-2.0863,4.61377,48.20588,48.20588,0,0,0,11.08917-3.65582c2.55572-1.20819,5.20056-2.87195,6.08716-5.55628A6.411,6.411,0,0,0,854.796,542.95306Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M547.28534,641.20471c.0448-2.13446-1.48663-4.45325-3.62146-4.46759a3.77441,3.77441,0,0,0-3.46887,3.16675,6.17425,6.17425,0,0,0,1.39587,4.753,18.30648,18.30648,0,0,0,3.80005,3.37915l.37683-1.37457a4.39653,4.39653,0,0,1-.8352.40967C546.081,645.27136,547.24054,643.33917,547.28534,641.20471Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M545.76776,646.66144a4.874,4.874,0,0,0,.89716-.74286c-.24683.04962-.49018.11548-.73773.16125Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M561.796,629.95306a7.31875,7.31875,0,0,0-7.07617-1.10046,8.54471,8.54471,0,0,0-4.98059,5.27179c-.77222,2.2951-.6131,4.78815-.988,7.18042a8.57141,8.57141,0,0,1-2.0863,4.61377,48.20588,48.20588,0,0,0,11.08917-3.65582c2.55572-1.20819,5.20056-2.87195,6.08716-5.55628A6.411,6.411,0,0,0,561.796,629.95306Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M226.28534,639.20471c.0448-2.13446-1.48663-4.45325-3.62146-4.46759a3.77441,3.77441,0,0,0-3.46887,3.16675,6.17425,6.17425,0,0,0,1.39587,4.753,18.30648,18.30648,0,0,0,3.8,3.37915l.37683-1.37457a4.39653,4.39653,0,0,1-.8352.40967C225.081,643.27136,226.24054,641.33917,226.28534,639.20471Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M224.76776,644.66144a4.874,4.874,0,0,0,.89716-.74286c-.24683.04962-.49018.11548-.73773.16125Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.796,627.95306a7.31875,7.31875,0,0,0-7.07617-1.10046,8.54471,8.54471,0,0,0-4.98059,5.27179c-.77222,2.2951-.6131,4.78815-.988,7.18042a8.57141,8.57141,0,0,1-2.0863,4.61377,48.20588,48.20588,0,0,0,11.08917-3.65582c2.55572-1.20819,5.20056-2.87195,6.08716-5.55628A6.411,6.411,0,0,0,240.796,627.95306Z",
    transform: "translate(-130.09442 -221.69963)",
    fill: "#f0f0f0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image_1.b9d3181f1a7144e35a1490364cc02a20.svg";
export { ForwardRef as ReactComponent };